module.exports = __webpack_public_path__ + "img/pt.b8743a6.svg";